export default "__VITE_ASSET__CuO95FP5__"